module.exports = __webpack_public_path__ + "img/ids_alerts.9098e28b.png";